/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/forms'] || initialState;

export const selectViewFormsState = createSelector(
  [selectDomain],
  (ViewFormsState) => ViewFormsState,
);
export const selectFilteredForms = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.filteredForms);
export const selectStateLoader = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.stateLoading);
export const selectFormId = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.formId);
export const selectUserSessionId = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.userSessionId);
export const selectUserModuleCompletionId = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.userModuleCompletionId);
export const selectLoader = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.loading);
export const selectModal = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.modal);
export const selectFormSettings = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.formSettings);
export const selectFormConfig = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.formConfig);
export const selectAnswerData = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.answerData);
export const selectSubmitStatus = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.status);
export const selectCreateStatus = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.createStatus);
export const selectCreationRedirectFrom = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.creationRedirectFrom);
export const selectSubmissionCreatedAt = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.createdAt);
export const selectSubmissionUpdatedAt = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.updatedAt);
export const selectFormConfigModal = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.formConfigModal);
export const selectChatIdForSingleChatFormShare = createSelector([selectDomain], (ViewFormsState) => ViewFormsState.chatIdForSingleChatFormShare);
